module.exports = __webpack_public_path__ + "static/img/day3.06f1ce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour2/day3.jpg
// module id = y8pv
// module chunks = 0